module.exports = __webpack_public_path__ + "img/20210613_192151.23c83096.jpg";